module.exports = __webpack_public_path__ + "ad.no2.22115005.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ad.no2.jpg
// module id = VNGM
// module chunks = 0